import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, useParams } from "react-router-dom";
import {
  Dao,
  Invitaion,
  Login,
  Register,
  Spot,
  Timeline,
  Homepages,
  Airdrop,
  LotteryComponent,
  Buycoins,
  MarketComponent,
  Helpcenter,
  Learns,
  Dataa,
  Newss,
  VirtualStart,
  FurthurPages,
  Twofa,
  Depositt,
  Withdraww,
  ResetPasswordd,
  AddressBook
} from "../pages";
import Layout from "../component/layout";
import OffLayout from "../component/offlineLayout";
import Protected from "./privateRoutes";
import { KlimaFurthur } from "../pages/virtualstart_furthur/klima_furthur";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {updatePath} from '../store/auth/auth'

const PublicRoutes = () => {

  const { isLogin, isLoginDummy ,path} = useSelector((state: any) => state.auth);
  const userID = sessionStorage.getItem("userid");
  const dispatch = useDispatch();

  console.log('path', path)
  const route = {
    login: "login",
    register: "register",
    resetPassword: "resetPassword",

  };
  useEffect(()=>{
  
  })
  useEffect(() => {
    const handlePopState = () => {
      dispatch(updatePath(window.location.pathname.slice(1)))  
    };
    window.addEventListener('popstate', handlePopState); 
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  },);
  return (
    <Router>
      <Routes>

        <Route path="/login" element={<Login />} />
       
        <Route path="/register" element={<OffLayout><Register /></OffLayout>} />
        <Route path="/resetPassword" element={<OffLayout>< ResetPasswordd /></OffLayout>} />
        

      </Routes>
      {
        path !== route.login && path !== route.register  && path !== route.resetPassword && <Layout>
          <Routes>
            <Route path="/" element={<Homepages />} />
            <Route
              path="/airdrop"
              element={
                <Airdrop />
              }
            ></Route>
            <Route
              path="/roadmap"
              element={
                <Timeline />
              }
            />
            <Route
              path="/invite"
              element={
                <Invitaion />
              }
            />
            <Route
              path="/dao"
              element={
                <Dao />
              }
            />
            <Route
              path="/spot"
              element={
                <Spot />
              }
            />
            <Route
              path="/lottery"
              element={
                <LotteryComponent />
              }
            />
            <Route
              path="/buycoin"
              element={
                <Buycoins />
              }
            />
            <Route
              path="/market"
              element={
                <MarketComponent />
              }
            />
            <Route
              path="/helpcenter"
              element={
                <Helpcenter />
              }
            />
            <Route
              path="/news"
              element={
                <Newss />
              }
            />
            <Route
              path="/learn"
              element={
             <Learns />
              }
            />
              <Route
              path="/withdraw/address"
              element={
             <AddressBook />
              }
            />
            <Route
              path="/data"
              element={
                <Dataa />
              }
            />
            <Route
              path="/virtualstart"
              element={
                <VirtualStart />
              }
            />
            <Route
              path="/virtualstart/furthur"
              element={
                <FurthurPages />
              }
            />
            <Route
              path="/settings/twofa"
              element={
                <Twofa />
              }
            />
            <Route
              path="/virtualstart/furthur/klimafurthur"
              element={
                <KlimaFurthur />
              }
            />
            <Route
              path="/deposit"
              element={
                <Depositt />
              }
            />
            <Route
              path="/withdraw"
              element={
                <Withdraww />
              }
            />
          </Routes>
        </Layout>
      }

    </Router>
  );
};
export default PublicRoutes;
